import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
    isLoading: false,
    error: null,
    unlockcodesItem: [],
};

const unlockcodeSlice = createSlice({
    name: 'Unlockcode',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getUnlockcodeSuccess(state, action) {
            state.isLoading = false;
            state.unlockcodesItem = action.payload;
        },

    },
});

export default unlockcodeSlice.reducer;

export const { startLoading, hasError, getUnlockcodeSuccess, toggleUnlockcodeSuccess } = unlockcodeSlice.actions;

export const getAllUnlockcodes = () => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.get('unlockcode/');
        dispatch(getUnlockcodeSuccess(response?.data?.data));
    } catch (error) {
        dispatch(hasError(error));
    }
};
